import { render, staticRenderFns } from "./FormResearch3.vue?vue&type=template&id=6d396c84&scoped=true&"
import script from "./FormResearch3.vue?vue&type=script&lang=js&"
export * from "./FormResearch3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d396c84",
  null
  
)

export default component.exports